import React, { useEffect, useState } from "react";
import PandCard from "../../components/PandCard/PandCard";
import "../PandenOverzicht/PandenOverzicht.css";
// import axiosInstance from "../../utils/axiosApi";
import axiosInstance from "../../utils/axiosKeycloakApi";
import NavBar from "../../components/Navbar/Navbar";
import { useKeycloak } from "@react-keycloak/web";


const PandenOverzicht = () => {
  let [panden, setPanden] = useState([]);
  const { keycloak, initialized } = useKeycloak();
  
  const getPanden = () => {

    if (!!keycloak.authenticated){
      localStorage.setItem("access_token", keycloak.token)
      console.log("user is authenticated, setting the access token");
    };
    if (!keycloak.authenticated){
      localStorage.setItem("access_token", null)
      window.location = "/app/";
      console.log("user is NOT authenticated, setting null token in local storage");
    };

    // axiosInstance.get("/panden/").then((response) => {
    //   console.log('here is response');
    //   console.log(response);
    //   setPanden(response.data);
    // });

   try{
    axiosInstance.get("/panden/").then((response) => {
      setPanden(response.data);
    });
   }catch (error){
      console.error("error fetching panden list", error);
   }




  }
  useEffect(() => {
    getPanden();
  }, []);

  // Genereert PandCards
  const toonPanden = () => {
    return panden.map((pand, index) => {
      return (
        <PandCard
          key={index}
          pandId={pand.id}
          afbeeldingURL={pand.afbeelding_url}
          pandnaam={pand.pandnaam}
          adres={pand.adres}
          omschrijving={pand.omschrijving}
        />
      );
    });
  };

  return (
    <>
      <NavBar />
      <section className="section">
        <div className="container box">
          <h1 className="title is-1">Pandenoverzicht</h1>
          <div className="panden-grid">{toonPanden()}</div>
        </div>
      </section>
    </>
  );
};

export default PandenOverzicht;
